<div
  id="sidebar"
  [ngClass]="_commonService.sidebarHidden() ? 'hide' : 'show'"
  class="sidebar-wrapper"
>
  <!-- White Panel Container -->
  <div class="sidebar-panel">
    <!-- Top Menu Items -->
    <ul class="side-menu top-menu">
      @for (item of topMenuItems; track item.id || item.name) {
        @if (item.id && item.name && item.icon) {
          <li class="menu-item">
            @if (item.children && item.children.length > 0) {
              <!-- Parent Menu Item with Sub-menu -->
              <div
                class="menu-link"
                [ngClass]="{
                  active: isActive(item.id),
                  expanded: isExpanded(item.id),
                }"
                [style.background-color]="isActive(item.id) ? '#fff7ed' : 'transparent'"
                (click)="handleMenuClick(item)"
              >
                <lucide-angular
                  [color]="isActive(item.id) ? '#F9A138' : '#64748b'"
                  [size]="20"
                  [img]="item.icon"
                  class="menu-icon"
                >
                </lucide-angular>
                <span class="menu-text" [style.color]="isActive(item.id) ? '#F9A138' : '#64748b'">{{ item.name }}</span>
                <lucide-angular
                  [color]="isActive(item.id) ? '#F9A138' : '#64748b'"
                  [size]="16"
                  [img]="ChevronUp"
                  class="chevron-icon"
                  [ngClass]="{ rotated: isExpanded(item.id) }"
                >
                </lucide-angular>
              </div>
              <!-- Sub-menu Items -->
              @if (isExpanded(item.id)) {
                @if (!_commonService.sidebarHidden()) {
                  <ul class="sub-menu">
                    @for (child of item.children; track child.id) {
                      <li class="sub-menu-item" [ngClass]="{ active: isSubTabActive(child.id) }">
                        <a
                          class="sub-menu-link"
                          [ngClass]="{ active: isSubTabActive(child.id) }"
                          (click)="handleMenuClick(item, child)"
                        >
                          <span>{{ child.name }}</span>
                        </a>
                      </li>
                    }
                  </ul>
                }
              }
            } @else {
              <!-- Regular Menu Item -->
              @if (item.id === 'performance-stats') {
                <a
                  class="menu-link"
                  [ngClass]="{ active: isActive(item.id) }"
                  [style.background-color]="isActive(item.id) ? '#fff7ed' : 'transparent'"
                  (click)="handleMenuClick(item)"
                >
                  <lucide-angular
                    [color]="isActive(item.id) ? '#F9A138' : '#64748b'"
                    [size]="20"
                    [img]="item.icon"
                    class="menu-icon"
                  >
                  </lucide-angular>
                  <span class="menu-text" [style.color]="isActive(item.id) ? '#F9A138' : '#64748b'">{{ item.name }}</span>
                </a>
              } @else {
                <a
                  [routerLink]="'/' + item.id"
                  [routerLinkActive]="'active'"
                  [routerLinkActiveOptions]="{ exact: item.id !== 'performance-stats' && item.id !== 'broker-settings' }"
                  class="menu-link"
                  [ngClass]="{ active: isActive(item.id) }"
                  [style.background-color]="isActive(item.id) ? '#fff7ed' : 'transparent'"
                >
                  <lucide-angular
                    [color]="isActive(item.id) ? '#F9A138' : '#64748b'"
                    [size]="20"
                    [img]="item.icon"
                    class="menu-icon"
                  >
                  </lucide-angular>
                  <span class="menu-text" [style.color]="isActive(item.id) ? '#F9A138' : '#64748b'">{{ item.name }}</span>
                </a>
              }
            }
          </li>
        }
      }
    </ul>

    <!-- Bottom Menu Items (Separator, Settings, Logout) -->
    <ul class="side-menu bottom-menu">
      @for (item of bottomMenuItems; track item.id || item.name || item.isSeparator) {
        @if (item.isSeparator) {
          <li class="menu-separator"></li>
        } @else if (item.id && item.name && item.icon) {
          <li class="menu-item">
            <a
              [routerLink]="item.id === 'logout' ? null : '/' + item.id"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
              class="menu-link"
              [ngClass]="{ logout: item.id === 'logout', active: isActive(item.id) }"
              [style.background-color]="isActive(item.id) && item.id !== 'logout' ? '#fff7ed' : 'transparent'"
              (click)="item.id === 'logout' && handleMenuClick(item)"
            >
              <lucide-angular
                [color]="isActive(item.id) ? '#F9A138' : '#64748b'"
                [size]="20"
                [img]="item.icon"
                class="menu-icon"
              >
              </lucide-angular>
              <span class="menu-text" [style.color]="isActive(item.id) ? '#F9A138' : '#64748b'">{{ item.name }}</span>
            </a>
          </li>
        }
      }
    </ul>
  </div>

  <!-- Footer -->
  <app-footer></app-footer>
</div>
